<div class="container">
  <div class="matchingPeriod-info">
    <div class="mat-caption">
      Current matching period <b>{{ currentMatchingPeriod }}</b>
    </div>
  </div>
  <div class="spacer"></div>
  <div class="button-container">
    <button color="accent" (click)="openDialog()" mat-button *ngIf="canCreateNewMatchingperiod">NEW</button>
  </div>
</div>
